import React, { Component } from 'react';
import classNames from 'classnames';
import { Tag, Divider } from 'antd';
import Selection from '../../common/Selection';
import { equals, isEmpty } from 'ramda';
import './index.less';
import { asserts } from '../../../utils';

const { CheckableTag } = Tag;

const TagSelectOption = ({ children, checked, onChange, value }) => (
  <CheckableTag
    checked={!!checked}
    key={value}
    onChange={(state) => onChange && onChange(value, state)}
  >
    {children}
  </CheckableTag>
);

TagSelectOption.isTagSelectOption = true;

export { TagSelectOption };

class TagSelect extends Component {
  static defaultProps = {
    showMultiple: true,
    control: false,
    actionsText: {
      expandText: '展开',
      multipleText: '多选',
    },
  };
  static Option = TagSelectOption;
  constructor(props) {
    super(props);
    // if (type(props.multiple) === 'Boolean' && type(props.onMultiple) !== 'Function') {
    //   const message =
    //     '[TagSelect]: if you set props multiple, its expect to implements props onMultiple, Cause it becomes a controled props.';
    //   console.warn(message); // eslint-disable-line
    // }
    this.state = {
      expand: props.defaultExpand || false,
      value: props.value || props.defaultValue || [],
      selectValue: props.selectValue || props.selectValue || [], // 下拉选择的仓库值
      multiple: props.multiple,
      addSelect: props.addSelect || false,
      addSetDefaultMcu: props.addSetDefaultMcu || false,
      selectList: props.selectList || [],
      cacheValue: [],
    };
  }

  static getDerivedStateFromProps(nextProps) {
    let update = {};
    if ('value' in nextProps) {
      update = { ...update, value: nextProps.value || [] };
    }
    if ('selectValue' in nextProps) {
      update = { ...update, selectValue: nextProps.selectValue || [] };
    }
    if ('multiple' in nextProps) {
      update = { ...update, multiple: nextProps.multiple || false };
    }
    return isEmpty(update) ? null : update;
  }

  onChange = (value) => {
    const { value: StateValue, multiple, selectValue } = this.state;
    const { onGetSelectValue, id } = this.props;
    if (equals(value, StateValue)) return;
    const { onChange } = this.props;
    if (id === 'CAT_34' && value && !multiple) {
      this.setState({ selectValue: [] });
      onGetSelectValue && onGetSelectValue([], multiple);
    }
    if (!('value' in this.props)) {
      this.setState({ value, cacheValue: [], selectValue: !multiple ? [] : selectValue });
    }
    if (onChange) {
      onChange(value);
    }
  };

  handleTagChange = (value, checked) => {
    const { value: StateValue, multiple, cacheValue, selectValue } = this.state;
    if (multiple) {
      const checkedTags = Array.from(new Set([...StateValue, ...selectValue]));
      const index = checkedTags.indexOf(value);
      if (checked && index === -1) {
        checkedTags.push(value);
      } else if (!checked && index > -1) {
        checkedTags.splice(index, 1);
      }
      this.onChange(checkedTags);
    } else {
      let checkedTags = [];
      if (checked) {
        checkedTags = [value];
      } else if (StateValue.length === 1) {
        checkedTags = StateValue.includes(value) ? [] : [value];
      } else {
        // just becomes single from multiple, now StateValue === 0. and its the first time its click.
        // so we can clear the cacheValue, Cause its no need to keep it.
        if (cacheValue.length > 1) checkedTags = [value];
        else checkedTags = cacheValue.includes(value) ? [] : [value];
        this.setState({ cacheValue: [] });
      }
      this.onChange(checkedTags);
    }
  };

  handleMultiple = (checked) => {
    const { value: StateValue, cacheValue } = this.state;
    const { onGetSelectValue, id } = this.props;
    if (checked) {
      // becomes multiple. nothing to do.
      if (isEmpty(StateValue) && !isEmpty(cacheValue)) {
        this.setState({ value: cacheValue, cacheValue: [] });
      }
    } else {
      // becomes single select.
      this.setState({
        value: [],
        selectValue: [],
        cacheValue: StateValue,
      });
      // id === 'CAT_34' && onGetSelectValue && onGetSelectValue([], checked);
    }
    const { onMultiple } = this.props;
    if (onMultiple) {
      onMultiple(checked);
    }
    this.setState({ multiple: checked });
  };

  handleExpand = () => {
    const { expand } = this.state;
    const { onExpand } = this.props;
    onExpand && onExpand(!expand);
    this.setState({
      expand: !expand,
    });
  };

  handleSelectChange = (e) => {
    const { onChange, onGetSelectValue } = this.props;
    const { multiple, value, selectList } = this.state;
    if (multiple) {
      // 多选
      selectList.forEach((item) => {
        let tempIndex = value.findIndex((itm) => itm === item.condVal);
        if (tempIndex > -1) {
          value.splice(tempIndex, 1);
        }
      });
      const checkedTags = multiple
        ? [...value, ...e]
        : asserts.isExist(e)
        ? [...value, e]
        : [...value];
      this.setState({
        selectValue: multiple ? e : [e],
        value,
      });
      onChange(checkedTags);
    } else {
      // 不是多选
      this.setState({
        selectValue: asserts.isExist(e) ? [e] : [],
        value: [],
      });
      onChange([e]);
    }
    onGetSelectValue && onGetSelectValue(e, multiple);
  };

  handleClearSelectValue = () => {
    this.setState({
      selectValue: [],
    });
  };

  isTagSelectOption = (node) =>
    node &&
    node.type &&
    (node.type.isTagSelectOption || node.type.displayName === 'TagSelectOption');

  render() {
    const {
      value,
      cacheValue,
      expand,
      multiple,
      addSelect,
      addSetDefaultMcu,
      selectList,
      selectValue,
    } = this.state;
    const {
      children,
      className,
      style,
      expandable,
      actionsText = {},
      control,
      expanded,
      showMultiple,
    } = this.props;
    const { expandText = '展开', multipleText = '多选' } = actionsText;

    const cls = classNames('tagSelect', className, {
      hasExpandTag: expandable || showMultiple,
      hasMore: expandable && showMultiple,
      expanded: !!control ? expanded : expand,
    });

    return (
      <div className={cls} style={style}>
        {value &&
          children &&
          React.Children.map(children, (child) => {
            if (this.isTagSelectOption(child)) {
              return React.cloneElement(child, {
                key: `tag-select-${child.props.value}`,
                value: child.props.value,
                checked: (isEmpty(value) ? cacheValue : value).indexOf(child.props.value) > -1,
                onChange: this.handleTagChange,
              });
            }
            return child;
          })}
        {addSelect ? (
          <div style={{ display: 'inline-block', width: '20%' }}>
            <Selection
              placeholder="查看其它仓，运费自付"
              transfer={{ key: 'id', name: 'condAlias', code: 'condVal' }}
              source={selectList}
              value={selectValue}
              onChange={this.handleSelectChange}
              allowClear
              mode={!!multiple ? 'multiple' : null}
            />
          </div>
        ) : null}
        {addSetDefaultMcu ? (
          <div style={{ display: 'inline-block', marginLeft: 12 }}>
            <p
              className="mcu-setDefault"
              onClick={() => window.open(`${process.env.TARGET}profile/defaultMcu`, '_blank')}
            >
              设置默认仓{'>>'}
            </p>
          </div>
        ) : null}

        {(expandable || showMultiple) && (
          <span className="trigger">
            {expandable && showMultiple && <Divider type="vertical" />}
            {expandable && (
              <CheckableTag
                className="tag-control pointer"
                checked={expand}
                onChange={this.handleExpand}
              >
                {expandText}
              </CheckableTag>
            )}
            {showMultiple && (
              <CheckableTag
                className="tag-control pointer"
                checked={multiple}
                onChange={this.handleMultiple}
              >
                {multipleText}
              </CheckableTag>
            )}
          </span>
        )}
      </div>
    );
  }
}

export default TagSelect;
